import type { IxfAccountingV1TransactionKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const ACCOUNTING_MANUAL_TRANSACTION_BASE_PATH = getResolvedPath('/clearing/finance/accounting/transaction');

export const getAccountingTransactionPath: EntityPathBuilder<IxfAccountingV1TransactionKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return ACCOUNTING_MANUAL_TRANSACTION_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.transactionId) {
        return undefined;
      }

      return getResolvedPath(`${ACCOUNTING_MANUAL_TRANSACTION_BASE_PATH}/$transactionId`, context?.keys);
    }
  }
};
